import clsx from 'clsx';
import { useAnalytics } from 'contexts/Analytics/Analytics';
import { useCalculator } from 'contexts/Calculator/Calculator';
import { useEffect, useState } from 'react';

export default function Step({ children, className, description, exportTitle, ordinal, show, title, onOpen }: StepProps) {

    const [open, setOpen] = useState(!!show);
    const [shown, setShown] = useState(show);
    const analytics = useAnalytics();
    const calculator = useCalculator();

    const onPanelExpanded = () => {
        setOpen(!open);
    };

    useEffect(() => {
        if (open && !shown) {
            setShown(true);
            onOpen?.();
            void analytics.trackActionEvent('action_tool_step_completed', {
                resource_id: `step_${ordinal}`,
                resource_type: 'step',
                source: 'step_panel',
            });
            if (ordinal === 3) {
                void analytics.trackActionEvent('action_tool_completed', {
                    resource_id: `step_${ordinal}`,
                    resource_type: 'tool',
                    source: 'step_panel',
                });
            }
        }
    }, [
        analytics,
        open,
        ordinal,
        shown,
        onOpen,
    ]);

    useEffect(() => {
        if (calculator.confidenceLevel && calculator.populationSize && calculator.targetMarginOfError && !open && !shown) {
            setOpen(true);
        }
    }, [calculator.confidenceLevel, calculator.populationSize, calculator.targetMarginOfError, open, shown]);

    const containerClasses = clsx("mb-5", className);

    const contentClasses = clsx("pdf-show", {
        "d-block": open
    });

    const toggleClasses = clsx("step-toggle", {
        open
    });

    return (
        <div className={containerClasses} data-testid={`step-${ordinal}`}>
            <div className="row mb-3">
                <hr />
            </div>
            <div className="mb-5">
                <div className="d-flex">
                    <div onClick={() => setOpen(true)}>
                        <span className="step-ordinal">
                            <span>{ordinal}</span>
                        </span>
                    </div>
                    <div className="flex-grow-1 mx-3" onClick={() => setOpen(true)}>
                        <div className="d-lg-flex">
                            <h2 className="text-nowrap" data-testid={`step-${ordinal}-heading`}>
                                <span className="pdf-hide">{title}</span>
                                <span className="pdf-show">{exportTitle}</span>
                            </h2>
                            <p className="pdf-hide mx-lg-5">{!open && description}</p>
                        </div>
                    </div>
                    <div className="pdf-hide">
                        <button
                            aria-label={`${open ? "Close" : "Open"} step ${ordinal}`}
                            className={toggleClasses}
                            data-testid={`step-${ordinal}-toggle`}
                            onClick={onPanelExpanded}
                            type="button"
                        />
                    </div>
                </div>
            </div>
            <div className={contentClasses}>{children}</div>
        </div>
    );
}
